export default __webpack_public_path__ + "paddle_traffic_hovere448a6.svg";